const qrAnalyticsTypes = {
    GET_QR_ANALYTICS_PENDING: "GET_QR_ANALYTICS_PENDING",
    GET_QR_ANALYTICS_SUCCESS: "GET_QR_ANALYTICS_SUCCESS",
    GET_QR_ANALYTICS_ERROR: "GET_QR_ANALYTICS_ERROR",
}

export default qrAnalyticsTypes;
